import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame31 = (props: TQrFrameProps) => {
	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: 'white'

	const getTextY = (fontSize: number) => {
		const boxTop = 63
		const boxHeight = 10
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				fillRule="evenodd"
				clipRule="evenodd"
				d="m11 23 6.5-.5 1.5 2 4 1 4-1 2-2h22V30h6l2.5 1 .5 2 .5 9.5V56l-1 2-2 1H51v4.5H11zm40 31h4l1-.5.5-7L56 37v-2l-4 .5-1-.333z"
				fill={frameBackgroundColor}
			/>
			<g id="frame" fill={frameColor}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M50.075 54.731h5.512c.882 0 1.613-.714 1.594-1.597V35.809c0-.883-.712-1.597-1.593-1.597h-5.513zm5.287-1.842h-3.43V36.054h3.43z"
				/>
				<path d="M20.544 16.605a.6.6 0 0 0 .375.15c.15 0 .3-.056.393-.17 1.875-2.029 4.782-4.453 7.838-4.359.9 0 1.781.188 2.625.489a.58.58 0 0 0 .712-.338.58.58 0 0 0-.337-.714 8.8 8.8 0 0 0-2.962-.564c-3.47-.094-6.638 2.518-8.682 4.716-.187.226-.187.583.038.79" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M2.638 44.716c0 3.589 2.53 5.186 4.312 5.186.863 0 1.669-.226 2.363-.677q.153-.101.3-.214v13.556h-.02v9a3.18 3.18 0 0 0 3.17 3.176h35.962a3.14 3.14 0 0 0 3.15-3.175v-4.68h.019v-7.196h4.875a4.586 4.586 0 0 0 4.575-4.585V33.836c0-2.518-2.063-4.585-4.575-4.585h-4.875V21.81h-.862a8.66 8.66 0 0 0-.113-4.322c-.619-2.218-2.081-4.04-4.088-5.168a8.47 8.47 0 0 0-6.544-.751q-.495.136-.97.335a14 14 0 0 0-2.31-2.158 13.6 13.6 0 0 0-8.213-2.744c-2.813 0-5.813 1.165-8.888 3.458-2.392 1.765-4.197 3.751-4.98 4.613l-.026.028-.047.057-.047.056c-.918.113-2.906.413-4.875 1.54-2.587 1.467-4.218 3.815-4.837 6.953-.703 3.54.035 6.423.577 8.539l.023.086.004.016c.336 1.29.632 2.43.39 3.047-.224.58-.615 1.344-1.024 2.147l-.008.014c-1.087 2.105-2.418 4.717-2.418 7.16m54.13 13.134h-6.712v4.717H11.45V23.65h5.708q.214.278.48.564c1.368 1.465 3.093 2.236 5.006 2.236 3.506 0 5.4-1.917 6.094-2.8h21.318v7.441h6.713a2.744 2.744 0 0 1 2.737 2.744v21.27a2.744 2.744 0 0 1-2.737 2.744M16.626 20.795c-.407.163-.616.596-.541 1.015H9.612v24.12a1 1 0 0 0-.037.082C9.05 47.384 8.15 48.08 6.95 48.08c-.787 0-2.456-.827-2.456-3.345 0-1.992 1.219-4.397 2.212-6.313.45-.865.863-1.673 1.125-2.35.443-1.164.105-2.475-.317-4.11l-.02-.08c-.544-2.048-1.2-4.622-.581-7.798.787-4.04 3.58-6.407 8.25-7.046q.072-.012.129-.017c.049-.006.09-.01.133-.02a.95.95 0 0 0 .506-.264c.045-.056.104-.12.18-.201l.177-.194c4.5-4.98 8.718-7.497 12.525-7.497 2.587 0 4.95.79 7.05 2.33a12.7 12.7 0 0 1 1.816 1.64 8.6 8.6 0 0 0-1.048.878c-.375.357-.375.92-.019 1.297a.9.9 0 0 0 1.294.018c.788-.789 1.782-1.353 2.869-1.672a6.63 6.63 0 0 1 5.138.582c1.593.884 2.737 2.312 3.225 4.06a6.6 6.6 0 0 1-.02 3.814H28.25a.95.95 0 0 0-.806.47l-.003.004-.007.01c-.127.2-1.488 2.353-4.79 2.353-1.388 0-2.606-.545-3.638-1.616-.806-.845-1.181-1.729-1.181-1.729-.187-.47-.731-.676-1.2-.488"
				/>
			</g>
			<rect
				id="qr-background"
				x={14.75}
				y={27.5}
				width={32}
				height={32}
				rx={2}
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 19.25,
							y: 32,
							width: 23,
							height: 23,
						}),
					}}
				/>
			) : (
				<MockQr x={19.25} y={32} width={23} height={23} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				xOffset={-1.25}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
